import { css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { updateTenantAttribute } from '../../tenant-attribute/update-tenant-attribute';
import { i18n } from '../../utils/i18n/i18n';

@customElement('as-mfa-cookie-settings')
export class MfaCookieSettings extends LitElement {
  static styles = css`
    sd-lit-slider {
      --slider-suffix-width: 70px;
      outline: none;
    }
  `;

  @property({ type: Boolean })
  private mfaCookieEnabled = false;

  @property({ type: Number })
  private mfaCookieLifetimeInDays = 1;

  render() {
    return html` <as-widget-group caption="${i18n('admin.mfa.cookieSettingsCaption')}">
      <as-vertical-layout>
        <div>${i18n('admin.mfa.cookieSettingsDescription')}</div>
        <sd-radio-button-group layout="horizontal" @value-change=${this.handleStatusChange}>
          <as-segmented-button value="true" ?checked=${this.mfaCookieEnabled}>
            ${i18n('common.active')}
          </as-segmented-button>
          <as-segmented-button value="false" ?checked=${!this.mfaCookieEnabled}>
            ${i18n('common.inactive')}
          </as-segmented-button>
        </sd-radio-button-group>
        <sd-lit-slider
          id="mfa-cookie-lifetime-slider"
          min="1"
          max="30"
          value="${this.mfaCookieLifetimeInDays}"
          step="1"
          clampValue="true"
          editable="true"
          inputSuffix="${i18n('common.days')}"
          ?disabled=${!this.mfaCookieEnabled}
          @value-change=${this.handleSliderChange}
        ></sd-lit-slider>
      </as-vertical-layout>
    </as-widget-group>`;
  }

  private async handleSliderChange(event: CustomEvent<{ value: number }>) {
    const updatedDays = event.detail.value;
    const javaDuration = `PT${updatedDays * 24}H`;
    await updateTenantAttribute('mfaCookieLifetime', javaDuration);
  }

  private async handleStatusChange(event: CustomEvent<{ value: string }>) {
    const updatedStatus = 'true' == event.detail.value;
    if (this.mfaCookieEnabled === updatedStatus) {
      return;
    }
    this.mfaCookieEnabled = updatedStatus;
    await updateTenantAttribute('mfaCookieEnabled', event.detail.value);
  }
}
